<br />
<div class="container">
  <div class="container-fluid container-shadow" style="overflow-y:auto;" *ngIf="isError">
    <app-error [message]="errorMessage"></app-error>
  </div>
</div>
<span *ngIf="isTaskloading" class="justify-content-center">
  <app-loading [displayeMessage]="true"></app-loading>
</span>
<div class="container-fluid" *ngIf="taskDetail">
  <div style="height: 40px;background:#EEEEEE 0% 0% no-repeat padding-box;width:100%;" class="border-4 border-bottom">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center pt-1"><span class="font-color-navy welcome-text">Task Details</span></h2>
      </div>
    </div>
  </div>  
  <br />
  <div class="container-fluid container-shadow font-color-navy px-5">
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="font-color-navy background-lightGrey px-1 py-2" id="Details">
          <span class="glyphicon glyphicon-calendar px-1"></span><span class="d-inline p-2 m-1 bold-text text-navy bg-light glyphicon glyphicon-calendar" alt="Request deadline date">Deadline: {{taskDetail.dueDate! | date:'medium'}}</span>
          <span class="glyphicon glyphicon-user px-1"></span><span alt="Requestor name" class="d-inline p-2 m-1 bold-text text-navy bg-light">Requestor: {{taskDetail.requestor}}</span>
          <span alt="Task status" class="d-inline p-2 m-2 text-white" [ngStyle]="{'backgroundColor':getCSSColorStatus()}">{{taskDetail.approvalStatus}}</span>
          <span title="Load Request Detail in New Tab"><svg height="19.96" width="20" style="cursor: pointer;" (click)="onrequestnavigate(taskDetail.requestId)" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>icon/20/icon-open-in-new</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Output-svg" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="out" transform="translate(-838.000000, -29.000000)" fill="#EE7D11"> <path d="M855,46 L841,46 L841,32 L848,32 L848,30 L841,30 C839.89,30 839,30.9 839,32 L839,46 C839,47.1 839.89,48 841,48 L855,48 C856.1,48 857,47.1 857,46 L857,39 L855,39 L855,46 L855,46 Z M850,30 L850,32 L853.59,32 L843.76,41.83 L845.17,43.24 L855,33.41 L855,37 L857,37 L857,30 L850,30 L850,30 Z" id="path"> </path> </g> </g> </g></svg></span>
          <span class="btn context-menu" title="View Task Response Details in Azure DevOps Services"><a href="{{taskDetail.externalLink}}" target="_blank" style="cursor:pointer;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.96" viewBox="0 0 20 19.96"><g id="View-in-Azure-icon" transform="translate(0 -2862)"><path id="azure_devops_logo_icon_145466" d="M0,11.156,1.872,8.686l7-2.848V3.78l6.142,4.493L2.471,10.707v6.856L0,16.85ZM20,7.448v12.21L15.2,23.74,7.454,21.194V23.74L2.471,17.562l12.549,1.5V8.272Z" transform="translate(0 2858.22)" fill="#ee7d11" /></g></svg></a></span>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion" id="accordionTaskDetails">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingTaskDetails">
              <button class="accordion-button-new" data-bs-toggle="collapse" data-bs-target="#collapseTask" aria-expanded="true" aria-controls="collapseTask">
                <i class="fa fa-caret-down px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Task Title</span>
              </button>
            </h3>
            <div id="collapseTask" class="accordion-collapse collapse show" aria-labelledby="headingTaskDetails" data-bs-parent="#accordionTaskDetails">
              <div>
                <b><span class="font-color-navy"><u>{{taskDetail.requirmentShortType}} {{taskDetail.requirmentId}}:-</u> {{taskDetail.requirmentTitle}}</span></b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion" id="accordionTaskDesc">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingTaskDesc">
              <button class="accordion-button-new" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTaskDesc" aria-expanded="true" aria-controls="collapseTaskDesc">
                <i class="fa fa-caret-down px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Description</span>
              </button>
            </h3>
            <div id="collapseTaskDesc" class="accordion-collapse collapse show" aria-labelledby="headingTaskDesc" data-bs-parent="#accordionTaskDesc">
              <div style="max-height:300px;overflow-y:scroll;">
                <div [innerHtml]="taskDetail.requirementDescription" class="font-color-navy"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion" id="accordionTaskComment">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingTaskComment">
              <button class="accordion-button-new" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTaskComment" aria-expanded="true" aria-controls="collapseTaskComment">
                <i class="fa fa-caret-down px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Comment(s)</span>
              </button>
            </h3>
          </div>
        </div>
        <div id="collapseTaskComment" class="accordion-collapse collapse show" aria-labelledby="headingTaskComment" data-bs-parent="#accordionTaskComment">
          <app-submit [responseId]="dataid"></app-submit>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion" id="accordionTaskStatus">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingTaskStatus">
              <button class="accordion-button-new" data-bs-toggle="collapse" data-bs-target="#collapseStatus" aria-expanded="true" aria-controls="collapseStatus">
                <i class="fa fa-caret-down px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Update Status</span>
              </button>
              <span *ngIf="isTasksubmitting" class="justify-content-center">
                <app-loading [displayeMessage]="true"></app-loading>
              </span>
            </h3>
            <div id="collapseStatus" class="accordion-collapse collapse show" aria-labelledby="headingTaskStatus" data-bs-parent="#accordionTaskStatus">
              <form (ngSubmit)="onTaskSubmit()" #taskSubmitForm="ngForm" ngForm="taskSubmitForm">
                <div *ngIf="this.taskDetail.isApprover">
                  <div *ngIf="this.taskDetail.requestType=='Approval'&& this.taskDetail.isApprover">
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="NotRelevant" [ngModel]="taskDetail.approvalStatus" required />
                        <span class="font-not-relevant h6">Not Relevant</span>
                      </label>
                    </span>
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="Needsmorework" [ngModel]="taskDetail.approvalStatus" required />
                        <span class="font-needsmorework h6">Needs More Work</span>
                      </label>
                    </span>
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="Approved" [ngModel]="taskDetail.approvalStatus" required />
                        <span class="font-approved h6">Approved</span>
                      </label>
                    </span>
                  </div>
                  <div *ngIf="this.taskDetail.requestType=='Acceptance' && this.taskDetail.isApprover">
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="NotRelevant" [ngModel]="taskDetail.approvalStatus" required />
                        <span class="font-not-relevant h6">Not Relevant</span>
                      </label>
                    </span>
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="CouldNotTest" [ngModel]="taskDetail.approvalStatus" required #reviewResponseCouldnotTest />
                        <span class="font-couldnottest h6">Could Not Test</span>
                      </label>
                    </span>
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="Rejected" [ngModel]="taskDetail.approvalStatus" required #reviewResponseTypeRejected />
                        <span class="font-needsmorework h6">Rejected</span>
                      </label>
                    </span>
                    <span class="px-3">
                      <label>
                        <input type="radio" class="radio-inline" name="reviewResponseType" value="Accepted" [ngModel]="taskDetail.approvalStatus" required />
                        <span class="font-approved h6">Accepted</span>
                      </label>
                    </span>
                    <div *ngIf="reviewResponseCouldnotTest.checked">
                      <textarea class="form-control-lg" rows="5" cols="100" [ngModel]="taskDetail.justification" name="justification" #justification="ngModel"></textarea>
                    </div>
                    <div *ngIf="reviewResponseTypeRejected.checked">
                      <div *ngIf="this.taskDetail.justificationType=='FreeText'">
                        <textarea class="form-control-lg" rows="5" cols="100" [ngModel]="taskDetail.justification" name="justification" #justification="ngModel"></textarea>
                      </div>
                      <div *ngIf="this.taskDetail.justificationType=='BugId'">
                        <div class="input-group">
                          <div matAutocompleteOrigin #bugOrigin="matAutocompleteOrigin">
                            <mat-form-field class="form-group">
                              <input type="text" placeholder="Search Bug by id or title" [formControl]="bugControl" matInput [matAutocomplete]="autoBugs"
                                     [matAutocompleteConnectedTo]="bugOrigin" class="form-control" required>
                              <mat-autocomplete [panelWidth]="'auto'" #autoBugs="matAutocomplete" (optionSelected)="onBugSelected($event)">
                                <mat-option *ngFor="let option of bugsfilteredOptions | async" [value]="option.id">
                                  {{option.title}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                            <span *ngIf="isBugLoading">
                              <app-loading [displayeMessage]="false"></app-loading>
                            </span>
                          </div>
                          <br />
                          <table class="table table-bordered table-striped" id="selectedBugs">
                            <thead class="table-secondary">
                              <tr>
                                <th class="font-color-navy">NUMBER</th>
                                <th class="font-color-navy">TITLE</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let bug of bugList; index as i" [attr.id]="bug.id">
                                <td>{{bug.id}}</td>
                                <td>{{bug.title}}</td>
                                <td><button id="remove" (click)="removeBug(bug)" class="btn-new-ui-xs">Remove</button></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!this.taskDetail.isApprover">
                  <span class="px-3">
                    <label>
                      <input type="radio" class="radio-inline" name="reviewResponseType" value="Completed" [ngModel]="taskDetail.approvalStatus" required />
                      <span class="font-not-relevant h6">Declare Review as Completed</span>
                    </label>
                  </span>
                </div>
                <div class="d-flexd-flex justify-content-end text-end" *ngIf="!taskSubmitted">
                  <button [ngClass]="(taskSubmitForm.valid) ? 'btn-new-ui':'btn-new-ui-disabled'"
                          type="submit"
                          [disabled]="(!taskSubmitForm.valid)">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion" id="accordionRelatedBugs">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingRelatedBugs">
              <button class="accordion-button-new" data-bs-toggle="collapse" data-bs-target="#collapseRelatedBugs" aria-expanded="false" aria-controls="collapseRelatedBugs">
                <i class="fa fa-caret-right px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Related Bug(s)</span>
              </button>
            </h3>
            <div id="collapseRelatedBugs" class="accordion-collapse collapse" aria-labelledby="headingRelatedBugs" data-bs-parent="#accordionRelatedBugs">
              <table class="table table-bordered table-striped" id="relatedBugs">
                <thead class="table-secondary">
                  <tr>
                    <th class="font-color-navy">NUMBER</th>
                    <th class="font-color-navy">TITLE</th>
                    <th class="font-color-navy">STATUS</th>
                    <th class="font-color-navy">SEVERITY</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let bug of relatedBugs; index as i" [attr.id]="bug.id">
                    <td>{{bug.id}}</td>
                    <td>{{bug.title}}</td>
                    <td>{{bug.status}}</td>
                    <td>{{bug.severity}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion accordion-flush" id="accordionTaskReviewer">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingTaskReviewer">
              <button class="accordion-button-new" data-bs-toggle="collapse" data-bs-target="#collapseTaskReviewer" aria-expanded="false" aria-controls="collapseTaskReviewer">
                <i class="fa fa-caret-right px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Reviewer(s) Status</span>
              </button>
            </h3>
            <div id="collapseTaskReviewer" class="accordion-collapse collapse" aria-labelledby="headingTaskReviewer" data-bs-parent="#accordionTaskReviewer">
              <app-reviewerspertask [requestId]="taskDetail.requestId" [requirementId]="taskDetail.requirmentId"></app-reviewerspertask>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="accordion" id="accordionRelatedRequests">
          <div class="accordion-item" style="border:none !important">
            <h3 class="font-color-navy bold-text background-lightGrey px-1" id="headingRelatedRequests">
              <button class="accordion-button-new" data-bs-toggle="collapse" data-bs-target="#collapseRelatedRequests" aria-expanded="false" aria-controls="collapseRelatedRequests">
                <i class="fa fa-caret-right px-1 font-color-orange"></i><span class="bold-text font-color-navy" style="font-size:20px !important">Related Request(s)</span>
              </button>
            </h3>
            <div id="collapseRelatedRequests" class="accordion-collapse collapse" aria-labelledby="headingRelatedRequests" data-bs-parent="#accordionRelatedRequests">
              <app-related-requests [requestId]="taskDetail.requestId" [requirementId]="taskDetail.requirmentId"></app-related-requests>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


